import React from "react";
import LegalLayout, { LegalSection, LegalList, LegalCallout } from "../../components/LegalLayout";
import SEO from "../../components/SEO";
import { ExternalLink } from "lucide-react";
import { COMPANY } from "../../config/COMPANY-INFO";

export default function DisputesPage() {
  return (
    <>
      <SEO
        title="Řešení spotřebitelských sporů"
        description="Jak řešit případný spor s Apex Detailing mimosoudně — Česká obchodní inspekce a síť evropských spotřebitelských center."
        path="/pravni/reseni-sporu"
      />
      <LegalLayout
      title="Řešení spotřebitelských sporů"
      subtitle="Mimosoudní cesta k vyřešení sporu, pokud bychom se nedohodli napřímo."
      testId="page-disputes"
    >
      <LegalSection id="uvod" title="1. Úvod">
        <p>
          Vaše spokojenost je pro nás nejdůležitější. Pokud byste s naší službou nebyli spokojeni, prosíme, dejte nám o tom vědět v co nejkratším čase na e-mailu{" "}
          <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a>{" "}
          nebo telefonicky na{" "}
          <a href={`tel:${COMPANY.contact.phoneRaw}`} className="text-apex-gold hover:underline">{COMPANY.contact.phone}</a>. Naprostou většinu situací se nám daří vyřešit po vzájemné domluvě.
        </p>
        <p>
          Pro případy, kdy bychom dohody nedosáhli, vám tato stránka shrnuje vaše práva na mimosoudní řešení sporu (ADR — Alternative Dispute Resolution).
        </p>
      </LegalSection>

      <LegalSection id="coi" title="2. Česká obchodní inspekce (ČOI)">
        <p>
          Subjektem mimosoudního řešení spotřebitelských sporů pro služby tohoto typu je v České republice <strong>Česká obchodní inspekce</strong>. Návrh na zahájení mimosoudního řízení můžete podat:
        </p>
        <LegalList>
          <li>elektronicky přes online formulář na webu <a href={COMPANY.links.coi} target="_blank" rel="noopener noreferrer" className="text-apex-gold hover:underline inline-flex items-center gap-1">adr.coi.cz <ExternalLink className="w-3 h-3" /></a></li>
          <li>e-mailem na <a href="mailto:adr@coi.cz" className="text-apex-gold hover:underline">adr@coi.cz</a></li>
          <li>poštou na adresu: Česká obchodní inspekce, Ústřední inspektorát — oddělení ADR, Štěpánská 567/15, 120 00 Praha 2</li>
        </LegalList>
        <p>Návrh lze podat do <strong>1 roku</strong> ode dne, kdy jste u nás své právo (typicky reklamaci) uplatnili poprvé. Postup ADR je pro spotřebitele bezplatný.</p>
      </LegalSection>

      <LegalSection id="odr" title="3. Řešení přeshraničních sporů v EU">
        <p>
          Evropská platforma pro online řešení sporů (ODR) byla k <strong>20. 7. 2025 trvale uzavřena</strong> Evropskou komisí a již není v provozu. Pro přeshraniční spotřebitelské spory v rámci EU se nyní obraťte na síť evropských spotřebitelských center:
        </p>
        <LegalCallout tone="info">
          <a href={COMPANY.links.eccNet} target="_blank" rel="noopener noreferrer" className="text-apex-gold hover:underline inline-flex items-center gap-1">
            eccnet.eu <ExternalLink className="w-3 h-3" />
          </a>
        </LegalCallout>
        <p className="text-sm text-apex-cream/65">
          Pro spory s naším (českým) provozovatelem doporučujeme přímo Českou obchodní inspekci (viz výše) — je to rychlejší a přímější cesta.
        </p>
      </LegalSection>

      <LegalSection id="rozhodne-pravo" title="4. Rozhodné právo">
        <p>
          Pro náš smluvní vztah a případné spory se uplatní <strong>právo České republiky</strong>, zejména zákon č. 89/2012 Sb. (občanský zákoník) a zákon č. 634/1992 Sb. (o ochraně spotřebitele). Soudní příslušnost se řídí obecnými pravidly českého práva.
        </p>
      </LegalSection>

      <LegalSection id="kontakt" title="5. Kontakt na nás">
        <p>Jakékoliv dotazy nebo stížnosti nám neváhejte poslat. Odpovídáme zpravidla do 24 hodin.</p>
        <LegalList>
          <li>E-mail: <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a></li>
          <li>Telefon: <a href={`tel:${COMPANY.contact.phoneRaw}`} className="text-apex-gold hover:underline">{COMPANY.contact.phone}</a></li>
          <li>Adresa: <strong>{COMPANY.address.full}</strong></li>
        </LegalList>
        <LegalCallout>
          Účinnost: <strong>{COMPANY.effectiveDate}</strong>.
        </LegalCallout>
      </LegalSection>
    </LegalLayout>
    </>
  );
}
